"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
const react_1 = require("@chakra-ui/react");
const THREE_SECONDS = 3000;
const defaultUseToastOptions = {
    duration: THREE_SECONDS,
    variant: "left-accent",
    isClosable: true,
    position: "top",
};
function useToast() {
    return (0, react_1.useToast)(Object.assign({}, defaultUseToastOptions));
}
exports.useToast = useToast;
